import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { ProductBinInputSchema } from "./set-product-bins";

export const bulkAddProductsToBin = {
  name: "bulkAddProductsToBin" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema).min(1),
    bin: ProductBinInputSchema,
  }),
  output: z.object({ addedCount: z.number(), skippedNoAuthCount: z.number() }),
};
